<template>
    <div>
        <v-server-table ref="workAreaTable" url="/subcontractors/work-area-list" :columns="columns" :options="options">
        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['state_name'],
                options: {
                    headings: {
                        state_name: 'Areas of Work',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'states.state_name',
                    },
                    columnsDropdown: false,
                    filterable: false,
                    sortable: [],
                    uniqueKey: 'state_name',
                },
            }
        }
    }
</script>
